import { TextFieldWithCheckbox } from "@/pages/caster/caster-data-entry-v2/components/form-fields/common/CheckboxFieldDE";
import { DurationFieldDE } from "@/pages/eaf/data-entry/components/form-fields/common/DurationFieldDE";
import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { useTableStyles } from "@/pages/heat-report/styles/useTableStyles";
import { getMomentTz } from "@dexteel/mesf-core";
import { Grid2 as Grid, Paper, TextField } from "@mui/material";
import { AssetCard } from "../../../controls/AssetCard";

const moment = getMomentTz();
export const HeaderData = () => {
	const {
		state: { casProcessData },
	} = useHeatReportContext();
	const classes = useTableStyles();

	return (
		<Paper className={classes.borderAgGridTable} elevation={0}>
			<Grid
				container
				spacing={2}
				sx={{ p: 1 }}
				key={`${casProcessData.ProcessId}`}
			>
				{/* Column 1 - Asset Card */}
				<Grid
					size={{ xs: 12, sm: 6, md: 2 }}
					container
					key={`${casProcessData.ProcessId}-column-1`}
				>
					<Grid size={{ xs: 12 }} key={`${casProcessData.ProcessId}-asset`}>
						<AssetCard
							assetId={casProcessData.AssetId || 13}
							assetName={casProcessData.AssetName || "Caster"}
						/>
					</Grid>
				</Grid>

				{/* Column 2 - Ladle Open & Close Times */}
				<Grid
					size={{ xs: 12, sm: 6, md: 2 }}
					container
					spacing={1}
					key={`${casProcessData.ProcessId}-column-2`}
				>
					<Grid size={{ xs: 12 }} container direction="row" spacing={1}>
						<Grid
							size={{ xs: 12 }}
							key={`${casProcessData.ProcessId}-ladle-open-time`}
						>
							<TextField
								label="Ladle Open"
								value={
									casProcessData?.LadleOpen
										? moment(casProcessData.LadleOpen).format(
												"HH:mm - MM/DD/YYYY",
											)
										: " "
								}
								variant="outlined"
								fullWidth
							/>
						</Grid>
						<Grid
							size={{ xs: 12 }}
							key={`${casProcessData.ProcessId}-ladle-close-time`}
						>
							<TextField
								label="Ladle Close"
								value={
									casProcessData?.LadleClose
										? moment(casProcessData.LadleClose).format(
												"HH:mm - MM/DD/YYYY",
											)
										: ""
								}
								variant="outlined"
								fullWidth
							/>
						</Grid>
					</Grid>
				</Grid>

				{/* Column 3 - Duration & Ladle Open Status */}
				<Grid
					size={{ xs: 12, sm: 6, md: 2 }}
					container
					spacing={1}
					key={`${casProcessData.ProcessId}-column-3`}
				>
					<Grid
						size={{ xs: 12 }}
						key={`${casProcessData.ProcessId}-duration-time`}
					>
						<DurationFieldDE
							label={"Duration [hh:mm:ss]"}
							value={
								casProcessData?.Duration
									? Number(casProcessData?.Duration)
									: null
							}
							unit={"seconds"}
							onChange={() => {}}
						/>
					</Grid>
					<Grid
						size={{ xs: 12 }}
						key={`${casProcessData.ProcessId}-did-ladle-open`}
					>
						<TextFieldWithCheckbox
							label="Did Ladle Open"
							checkboxValue={casProcessData?.IsFreeOpen ? true : false}
							onCheckboxChange={() => {}}
							disabled
						/>
					</Grid>
				</Grid>

				{/* Column 4 - Foreman & Cast Tons */}
				<Grid
					size={{ xs: 12, sm: 6, md: 2 }}
					container
					spacing={1}
					key={`${casProcessData.ProcessId}-column-4`}
				>
					<Grid size={{ xs: 12 }} container direction="row" spacing={1}>
						<Grid size={{ xs: 12 }} key={`${casProcessData.ProcessId}-foreman`}>
							<TextField
								label="Foreman"
								value={casProcessData?.Foreman ?? ""}
								variant="outlined"
								fullWidth
							/>
						</Grid>
						<Grid
							size={{ xs: 12 }}
							key={`${casProcessData.ProcessId}-cast-tons`}
						>
							<TextField
								label="Cast Tons"
								value={casProcessData?.CastTons?.toFixed(1) ?? ""}
								variant="outlined"
								fullWidth
							/>
						</Grid>
					</Grid>
				</Grid>

				{/* Column 5 - Nozzle & Tundish Data */}
				<Grid
					size={{ xs: 12, sm: 6, md: 2 }}
					container
					spacing={1}
					key={`${casProcessData.ProcessId}-column-5`}
				>
					<Grid size={{ xs: 12 }} container direction="row" spacing={1}>
						<Grid size={{ xs: 12 }} key={`${casProcessData.ProcessId}-nozzle`}>
							<div className={classes.container}>
								<TextField
									className={`${classes.field} ${classes.leftField}`}
									label="Nozzle"
									variant="outlined"
									size="small"
									value={casProcessData?.NozzleSize || ""}
								/>
								<TextField
									className={`${classes.field} ${classes.rightField}`}
									label="Heats On Nozzle"
									variant="outlined"
									size="small"
									value={casProcessData?.HeatsOnNozzle || ""}
								/>
							</div>
						</Grid>
						<Grid size={{ xs: 12 }} key={`${casProcessData.ProcessId}-tundish`}>
							<div className={classes.container}>
								<TextField
									className={`${classes.field} ${classes.leftField}`}
									label="Tundish"
									variant="outlined"
									size="small"
									value={casProcessData?.NozzleSize || ""}
								/>
								<TextField
									className={`${classes.field} ${classes.rightField}`}
									label="Heats On Tundish"
									variant="outlined"
									size="small"
									value={casProcessData?.HeatsOnTundish || ""}
								/>
							</div>
						</Grid>
					</Grid>
				</Grid>

				{/* Column 6 - Shroud & Pourback Data */}
				<Grid
					size={{ xs: 12, sm: 6, md: 2 }}
					container
					spacing={1}
					key={`${casProcessData.ProcessId}-column-6`}
				>
					<Grid
						size={{ xs: 12 }}
						key={`${casProcessData.ProcessId}-tundish-shroud`}
					>
						<div className={classes.container}>
							<TextField
								className={`${classes.field} ${classes.leftField}`}
								label="Shroud"
								variant="outlined"
								size="small"
								value={casProcessData?.TundishShroudName || ""}
							/>
							<TextField
								className={`${classes.field} ${classes.rightField}`}
								label="Heats On Shroud"
								variant="outlined"
								size="small"
								value={casProcessData?.HeatsOnTundishShroud || ""}
							/>
						</div>
					</Grid>
					<Grid
						size={{ xs: 12 }}
						key={`${casProcessData.ProcessId}-pourback-weight`}
					>
						<TextField
							label="Pourback"
							value={casProcessData?.PourbackWeight?.toFixed(1) ?? ""}
							variant="outlined"
							fullWidth
						/>
					</Grid>
				</Grid>
			</Grid>
		</Paper>
	);
};
